import { Component, ElementRef, Input, NgModule, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SummaryFieldModule } from '../../summary-field/summary-field.module';
import { TextOverflowModule } from '../../../../../shared/directives/text-overflow.module';
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
    selector: 'app-comment-summary-field',
    template: `
        <app-summary-field [maxLength]="maxLength"
                           *ngIf="comment"
                           [value]="comment"
                           [label]="label"
                           [iconName]="displayIcon ? 'message' : undefined"
                           textOverflow></app-summary-field>
    `,
})
export class CommentSummaryFieldComponent {
    @Input() comment: string;
    @Input() maxLength = 15;
    @Input() displayIcon = true;
    @Input() label;
    @ViewChild('valueSummary') valueSummaryElement: ElementRef;
}


@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SummaryFieldModule,
        TextOverflowModule,
        MatTooltipModule,
    ],
    declarations: [
        CommentSummaryFieldComponent,
    ],
    exports: [
        CommentSummaryFieldComponent,
    ],
})
export class CommentSummaryFieldModule {
}
